module.exports = __webpack_public_path__ + "static/media/gear-icon.efaaee92.svg";